// extracted by mini-css-extract-plugin
export default {"articleThumbnail":"ArticleThumbnail-module--articleThumbnail--cb586","imageWrapper":"ArticleThumbnail-module--imageWrapper--f8106"};